.defaultFieldContainer {
  width: 100%;
}

.borderTop {
  border-top: 1px solid var(--via-color-neutral-300);
  padding-top: var(--via-space-400);
}

.borderBottom {
  border-bottom: 1px solid var(--via-color-neutral-300);
  padding-bottom: var(--via-space-400);
}

.banner.banner {
  margin: var(--via-space-200) 0;
}
